import { createColumnHelper } from "@tanstack/table-core";
import { ActionCell } from "./ColumnUtils";
const columnHelper = createColumnHelper();

const EmployeeTableColumns = (t, onEdit, onRefresh) => {
  return [
    columnHelper.accessor("serial_no", {
      header: t("pages.employee.table.serial_number"),
      size: 1,
      muiTableBodyCellProps: {
        sx: {
          ".MuiCheckbox-root": {
            padding: 0,
            color: "#D9A62E !important",
          },
          textAlign: "left",
          fontSize: { xs: "2.09vw", sm: "1.2vw", md: "0.833vw" },
          color: "#474747",
          paddingY: { xs: "2vw", sm: "0.7vw" },
          zIndex: 1,
          fontWeight: 400,
          borderColor: "rgb(246, 210, 127)",
          "&.MuiTableCell-root:first-of-type": {
            position: "sticky",
            left: 0,
            zIndex: 2,
            "@media (max-width: 768px)": {
              position: "relative",
            },
          },
        },
      },
      enableSorting: false,
    }),
    columnHelper.accessor("name", {
      header: t("pages.employee.table.name"),
      muiTableBodyCellProps: {
        sx: {
          ".MuiCheckbox-root": {
            padding: 0,
            color: "#D9A62E !important",
          },
          textAlign: "left",
          fontSize: { xs: "2.09vw", sm: "1.2vw", md: "0.833vw" },
          color: "#474747",
          paddingY: { xs: "2vw", sm: "0.7vw" },
          zIndex: 1,
          fontWeight: 400,
          borderColor: "rgb(246, 210, 127)",
          "&.MuiTableCell-root:first-of-type": {
            position: "sticky",
            left: 0,
            zIndex: 2,
            "@media (max-width: 768px)": {
              position: "relative",
            },
          },
        },
      },
      size: 50,
      enableSorting: false,
    }),
    columnHelper.accessor("mobile", {
      header: t("pages.employee.table.mobile_number"),
      muiTableBodyCellProps: {
        sx: {
          ".MuiCheckbox-root": {
            padding: 0,
            color: "#D9A62E !important",
          },
          textAlign: "left",
          fontSize: { xs: "2.09vw", sm: "1.2vw", md: "0.833vw" },
          color: "#474747",
          paddingY: { xs: "2vw", sm: "0.7vw" },
          zIndex: 1,
          fontWeight: 400,
          borderColor: "rgb(246, 210, 127)",
          "&.MuiTableCell-root:first-of-type": {
            position: "sticky",
            left: 0,
            zIndex: 2,
            "@media (max-width: 768px)": {
              position: "relative",
            },
          },
        },
      },
      size: 50,
      enableSorting: false,
    }),
    columnHelper.accessor("alternate_mobile", {
      header: t("pages.employee.table.emergency_number"),
      muiTableBodyCellProps: {
        sx: {
          ".MuiCheckbox-root": {
            padding: 0,
            color: "#D9A62E !important",
          },
          textAlign: "left",
          fontSize: { xs: "2.09vw", sm: "1.2vw", md: "0.833vw" },
          color: "#474747",
          paddingY: { xs: "2vw", sm: "0.7vw" },
          zIndex: 1,
          fontWeight: 400,
          borderColor: "rgb(246, 210, 127)",
          "&.MuiTableCell-root:first-of-type": {
            position: "sticky",
            left: 0,
            zIndex: 2,
            "@media (max-width: 768px)": {
              position: "relative",
            },
          },
        },
      },
      size: 40,
      enableSorting: false,
    }),
    columnHelper.accessor("dob", {
      header: t("pages.employee.table.dob"),
      muiTableBodyCellProps: {
        sx: {
          ".MuiCheckbox-root": {
            padding: 0,
            color: "#D9A62E !important",
          },
          textAlign: "left",
          fontSize: { xs: "2.09vw", sm: "1.2vw", md: "0.833vw" },
          color: "#474747",
          paddingY: { xs: "2vw", sm: "0.7vw" },
          zIndex: 1,
          fontWeight: 400,
          borderColor: "rgb(246, 210, 127)",
          "&.MuiTableCell-root:first-of-type": {
            position: "sticky",
            left: 0,
            zIndex: 2,
            "@media (max-width: 768px)": {
              position: "relative",
            },
          },
        },
      },
      size: 50,
      enableSorting: false,
    }),
    columnHelper.accessor("gender", {
      header: t("pages.employee.table.gender"),
      muiTableBodyCellProps: {
        sx: {
          ".MuiCheckbox-root": {
            padding: 0,
            color: "#D9A62E !important",
          },
          textAlign: "left",
          fontSize: { xs: "2.09vw", sm: "1.2vw", md: "0.833vw" },
          color: "#474747",
          paddingY: { xs: "2vw", sm: "0.7vw" },
          zIndex: 1,
          fontWeight: 400,
          borderColor: "rgb(246, 210, 127)",
          "&.MuiTableCell-root:first-of-type": {
            position: "sticky",
            left: 0,
            zIndex: 2,
            "@media (max-width: 768px)": {
              position: "relative",
            },
          },
        },
      },
      size: 50,
      enableSorting: false,
    }),
    columnHelper.accessor("email", {
      header: t("pages.employee.table.mail"),
      muiTableBodyCellProps: {
        sx: {
          ".MuiCheckbox-root": {
            padding: 0,
            color: "#D9A62E !important",
          },
          textAlign: "left",
          fontSize: { xs: "2.09vw", sm: "1.2vw", md: "0.833vw" },
          color: "#474747",
          paddingY: { xs: "2vw", sm: "0.7vw" },
          zIndex: 1,
          fontWeight: 400,
          borderColor: "rgb(246, 210, 127)",
          "&.MuiTableCell-root:first-of-type": {
            position: "sticky",
            left: 0,
            zIndex: 2,
            "@media (max-width: 768px)": {
              position: "relative",
            },
          },
        },
      },
      size: 50,
      enableSorting: false,
    }),
    columnHelper.accessor("action", {
      header: t("pages.employee.table.actions"),
      size: 50,
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <ActionCell
          t={t}
          data={row.original}
          onEdit={onEdit}
          onRefresh={onRefresh}
        />
      ),
    }),
  ];
};

export default EmployeeTableColumns;
